import {DarkStoreType} from "../../../../common/types";
import ReactApexChart from "react-apexcharts";
import React from "react";

type RegionsIndicatorsPropsType = {
    data: DarkStoreType[];
}

export const RegionsIndicators = ({data}: RegionsIndicatorsPropsType) => {
    // Объект для хранения количества дарксторов по каждому городу
    let counts: { [key: string]: number} = {}
    // Перебираем все объекты данных и считаем количество дарксторов по городам
    data.forEach((el) => {
        if (!Object.keys(counts).includes(el.city)){
            counts = {...counts, [el.city]: 1} // Если город встречается впервые, инициализируем счётчик
        } else {
            counts[el.city] += 1 // Если город уже есть, увеличиваем счётчик
        }
    })

    // Массив городов для оси X (категории)
    const categories = Object.keys(counts)
    // Массив значений для графика (количество дарксторов по городам)
    const series = Object.values(counts)

    // Опции для графика ApexCharts
    const options = {
        chart: {
            width: 380,
            type: 'pie' as const, // Тип графика: круговая диаграмма
        },
        labels: categories, // Подписи для секторов
        title: {
            text: 'Количество дарксторов по регионам', // Заголовок графика
            align: 'center' as const,
            margin: 20,
            style: {

                fontSize: '16px',
                fontWeight: 'bold' as const,
                color: '#FFFFFF'
            },
        },
        legend: {
            labels: {
                colors: '#FFFFFF' // Цвет подписей легенды
            },
            position: 'bottom' as const // Положение легенды
        },
        responsive: [{
            breakpoint: 480,
            options: {
                chart: {
                    width: 200 // Ширина графика для мобильных устройств
                },
                legend: {
                    position: 'bottom'
                }
            }
        }]
    }

    // Рендерим круговую диаграмму по регионам
    return (
        <div>
            <ReactApexChart
                options={options}
                series={series}
                type={'pie'}
                height={500}
                style={{color: '#FFFFFF'}}
            />
        </div>
    );
};
